import toast from 'react-hot-toast';
import { blue, independence, red } from '../../styles';

const style = {};

export const UIToast = {
    success: (message: string) => {
        toast.success(message, {
            style,
            iconTheme: {
                primary: blue,
                secondary: 'white'
            }
        });
    },
    error: (message: string) => {
        toast.error(message, {
            style,
            iconTheme: {
                primary: red,
                secondary: 'white'
            }
        });
    },
    loading: (message: string) => {
        toast.loading(message, {
            style,
            iconTheme: {
                primary: independence,
                secondary: 'white'
            }
        });
    },
    dismiss: () => {
        toast.dismiss();
    }
};
